<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Código da Loja">
        <input class="form-input" v-model="config.auth.sellerCode">
      </form-group>
      <form-group label="Token">
        <input class="form-input" v-model="config.auth.token">
      </form-group>
    </div>

    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>

        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>

        <form-group label="Máximo de parcelas padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.maxInstallment">
        </form-group>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('order.label')">
      <div class="l-row">
        <form-group label="Tempo (em dias) para resgate de pedidos">
          <input class="form-input" min="1" type="number" v-model="config.order.daysToRetrieve">
          <small class="form-help">Pedidos que foram atualizados no intervalo de dias configurado irão ser resgatados para o Hub.</small>
        </form-group>
        <order-retrieve-date-configuration :orderConfigs="config.order" :columns="6"/>
      </div>
    </panel>
  </module-configuration>
</template>

<script>
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'ricardoEletro'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'ricardoEletro',
      config: {
        auth: {
          environment: 'sandbox',
          sellerCode: null,
          token: null
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          },
          maxInstallment: 0
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          }
        }
      }
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    components: {
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// RicardoEletro.vue?294e9b4c